import React, {useEffect, useState} from "react";
import {ListContainer} from "components/common";
import {FormButtons} from "_constants";
import {IDataField} from "interfaces";

import {IAward} from "interfaces/IAward";
import {adminSignalAlertApiService} from "services/AdminApiService";
import {AwardTypeEnum} from "predictagram-lib";
import { useNavigate } from "react-router-dom";
import { UrlHelper } from "_utils/UrlHelper";
import {Checkbox} from "../../../common/form/Checkbox";

export const AdminSignalAlertList: React.FunctionComponent = () => {

  const navigate = useNavigate();

  const [showPerfCol, setShowPerfCol] = useState<boolean>(true);

  const [fieldsList, setFieldList] = useState<any>([]);

  const editLink = (row: any) => {
    return <button className="btn btn-secondary" type="button" onClick={() => {
      const url = `/admin/analysis/strategy-profit?id=${row.id}`;
      navigate(url);
     }}>
      Edit
    </button>
  }

  const cacheStats = (row: any) => {
    const renderHist = (d:any, pref:any) => {
      if (!d) {
        return 'N/A';
      }
      return `${pref}: ${(d.score.overall*100).toFixed(2)}% trades ${d.trades.total}`;
    }
    return <div>
      <div>{renderHist(row.cache.last7, 'Last 7')}</div>
      <div>{renderHist(row.cache.last30, 'Last 30')}</div>
      <div>{renderHist(row.cache.last90, 'Last 90')}</div>
      <div>{renderHist(row.cache.last150, 'Last 150')}</div>
    </div>
  }


  useEffect(()=>{


    const fields: Map<string, [string, Function | undefined]> = new Map([
      ['id', ['ID', undefined]],
      ['name', ['Name', undefined]],
      ['emails', ['Emails', (v:any)=>v.emails.join(', ')]],
      ['symbol', ['Symbol', (v:any)=>v.data.symbolName]],
      ['performance', ['Performance', cacheStats]],
      ['edit', ['Edit', editLink]],
    ]);
    if (!showPerfCol) {
      fields.delete('performance');
    }
    setFieldList(fields);
  }, [showPerfCol]);

  const emptyValues = {
    name: '',
    description: '',
    image: '',
    typeId: AwardTypeEnum.BADGE,
  } as IAward

  const editableFields: IDataField[] = [
    { name: 'id', title: 'ID', editable: false },
    { name: 'name', title: 'Name', editable: true },
  ];


  return (
    <>
    <div className="d-flex justify-content-between align-items-end">
    <div className="page-title">Signal Alerts</div>
    <Checkbox label="Show Profit" value={showPerfCol} onChange={() => setShowPerfCol(!showPerfCol)} />
    <button className="btn btn-primary mt-2" onClick={()=>navigate(UrlHelper.getAdminSignalAlertAdd())}>Create New Signal Alert</button>
    </div>
      <ListContainer
        apiService={adminSignalAlertApiService}
        emptyValues={emptyValues}
        fieldList={fieldsList}
        buttons={[FormButtons.DELETE]}
        editableFields={editableFields}
      >
        {({ isEditing, onSuccess, initialValues, onCancelClick, editableFields }) => {
          return (
           <></>
          );
        }}
      </ListContainer>
    </>
  );
};
